export default __webpack_public_path__ + "static/media/Kintsugi_mias_metamorphosis.90cda746.png";